import { render } from "./commodity_analysis.vue?vue&type=template&id=6376e8ea&scoped=true&ts=true"
import script from "./commodity_analysis.vue?vue&type=script&lang=ts"
export * from "./commodity_analysis.vue?vue&type=script&lang=ts"

import "./commodity_analysis.vue?vue&type=style&index=0&id=6376e8ea&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6376e8ea"]])

export default __exports__